import script from "./play.vue?vue&type=script&setup=true&lang=js"
export * from "./play.vue?vue&type=script&setup=true&lang=js"

import "./play.vue?vue&type=style&index=0&id=27dc618c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27dc618c"]])

export default __exports__